/**
 * As regras dos campos da criação de organização, sem tela.
 *
 * Moram aqui porque as duas formas do formulário as usam: a de hoje e a com
 * contrato (#765, fase 4), que entra quando a API aceitar os campos novos.
 */

/** O mesmo formato que a API aceita: minúsculas, números e hífen, de 3 a 32. */
export const SLUG_VALIDO = /^[a-z0-9](?:[a-z0-9-]{1,30}[a-z0-9])$/;

export const EMAIL_VALIDO = /^\S+@\S+\.\S+$/;

/** O identificador sugerido a partir do nome: sem acento, minúsculo, com hífen. */
export function slugDoNome(nome: string): string {
  return nome
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 32)
    .replace(/-+$/g, '');
}
